import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  duplicateCustomSurveyTemplate,
  type CustomSurveyTemplate,
} from '../../api/customSurveyTemplates';
import { customSurveyTemplateKeys } from '../queries/queryKeys';

export const useDuplicateCustomSurveyTemplateMutation = (options?: {
  onSuccess?: (data: CustomSurveyTemplate) => void;
  onError?: (error: Error) => void;
}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => duplicateCustomSurveyTemplate(id),
    onSuccess: (data) => {
      // Invalidate all template queries to refetch and show the new duplicate
      queryClient.invalidateQueries({ queryKey: customSurveyTemplateKeys.all });
      options?.onSuccess?.(data);
    },
    onError: (error: Error) => {
      options?.onError?.(error);
    },
  });
};
